import { useTranslation } from 'next-i18next'

import { ExternalLink } from '~/components/ExternalLink'
import { media } from '~/donation/constants/sponsors.const'
import ResponsiveImage from '~/components/Image/ResponsiveImage'

const MediaPage = (): React.ReactElement => {
  const { t } = useTranslation('donation')

  return (
    <section className="flex flex-col items-center md:pt-5 mb-11">
      <h1 className="w-64 text-center text-white font-bold leading-9 tracking-widest text-shadow-donation text-h3">
        {t('media.label')}
      </h1>
      <div className="grid md:grid-cols-2 xl:grid-cols-3 mt-12 gap-5 xl:gap-9">
        {media.map((mediaData) => (
          <div className="flex flex-col gap-y-3.5  font-features" key={mediaData.title}>
            <ExternalLink href={mediaData.link}>
              <div className="border border-white rounded overflow-hidden bg-white flex items-center w-69 h-78">
                <ResponsiveImage
                  alt={mediaData.imageAlt}
                  height={313}
                  imageWidths="276"
                  loading="eager"
                  mediaQuery={mediaData.mediaQuery}
                  srcKey={mediaData.imageSrc}
                  width={276}
                />
              </div>
            </ExternalLink>

            <div className="text-white tracking-wider flex flex-col items-start gap-y-3.5">
              <div className="text-xxs font-normal h-8">{mediaData.publishDate}</div>
              <ExternalLink className="text-md w-57 font-medium text-left" href={mediaData.link}>
                {mediaData.title}
              </ExternalLink>
              <ExternalLink className="text-sm font-normal h-8 cursor-pointer" href={mediaData.link}>
                {mediaData.linkTitle}
              </ExternalLink>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default MediaPage
